var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('p',{staticClass:"d-flex justify-center"},[_vm._v("Copyright © 2022 - 2026 | LéoLearning")])])
}]

export { render, staticRenderFns }